
import Vue from "vue";

export default Vue.extend({
  name: "GroupListTable",
  props: {
    items: { type: Array, required: true },
    total: { type: Object, default: null },
    totalCount: { type: Number, required: true },
    headers: { type: Array, required: true },
    isYen: { type: Boolean, required: true },
    groupBys: { type: Array, required: true },
    currentGroupBy: { type: String, required: true },
  },
  data() {
    return {
      columnDetailDialog: false,
      temporaryDigestRateBase: "quantity",
      sortBy: "salesResultAmount",
      sortDesc: true,
    };
  },
  computed: {
    filteredGroupBys(): any[] {
      return this.groupBys.filter((gb: any) => gb.key !== this.currentGroupBy);
    },
  },
  methods: {
    formatYoY(val: number | null) {
      return val == null ? " - %" : `${val}%`;
    },
    formatPercent(val: number | null) {
      return val == null ? "- %" : `${val}%`;
    },
    formatMoney(val: number) {
      if (val == null) return "-";
      return this.isYen ? `¥${val.toLocaleString()}` : val.toLocaleString();
    },
    applyColumnDetail() {
      this.$emit("update-digest-base", this.temporaryDigestRateBase);
      this.columnDetailDialog = false;
    },
  },
});
